// Server messages for review-transition errors are safe to surface, but
// defensively strip anything multi-line (stack traces leak through in
// non-release envs) and hard-cap the length so a regression can't accidentally
// render server internals.
export const MAX_TOAST_ERROR_MESSAGE_LENGTH = 300;

export function safeToastMessage(rawMessage: string | undefined): string | null {
  if (!rawMessage) return null;
  const firstLine = rawMessage.split("\n")[0].trim();
  if (!firstLine) return null;
  return firstLine.length > MAX_TOAST_ERROR_MESSAGE_LENGTH
    ? `${firstLine.slice(0, MAX_TOAST_ERROR_MESSAGE_LENGTH - 1)}…`
    : firstLine;
}
